export class FixedToolMeasurement {
  constructor(
    public hash?: string,
    public modelHash?: string,
    public modelName?: string,
    public modelReference?: string,
    public toolHash?: string,
    public toolName?: string,
    public toolHolderHash?: string,
    public toolHolderName?: string,
    public length?: number,
    public z?: number,
    public x?: number,
    public concentricity?: number
  ) { }

  get modelNameReference() {
    return (this.modelReference) ? `${ this.modelName } ${ this.modelReference }` : this.modelName;
  }

  clone() {
    return new FixedToolMeasurement(
      this.hash,
      this.modelHash,
      this.modelName,
      this.modelReference,
      this.toolHash,
      this.toolName,
      this.toolHolderHash,
      this.toolHolderName,
      this.length,
      this.z,
      this.x,
      this.concentricity
    );
  }

  get filterableData() {
    return `${ this.modelName } ${ this.modelReference } ${ this.toolName } ${ this.toolHolderName }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/fixed-tool-measurement.ts